export function Kpi({ v, l, small }) {
  return (
    <div className="kpi">
      <div className={small ? 'kpi-v kpi-v-sm' : 'kpi-v'}>{v}</div>
      <div className="kpi-l">{l}</div>
    </div>
  );
}

export function Kpis({ children }) {
  return <div className="kpis">{children}</div>;
}
